(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[538],{

/***/ 93223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map",
      function () {
        return __webpack_require__(19734);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Config; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var utils_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92233);



function Config(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            refreshInterval: 1000 * 60 * 2,
            fetcher: function(q, variables) {
                return (0,utils_query__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(q, variables);
            },
            fallback: fallback
        },
        children: children
    });
};


/***/ }),

/***/ 19734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ MapPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-mapkit/dist/index.js
var dist = __webpack_require__(56687);
// EXTERNAL MODULE: ./components/config.jsx
var config = __webpack_require__(43738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(10251);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ./utils/fetcher.js
var fetcher = __webpack_require__(62412);
// EXTERNAL MODULE: ./utils/const.js
var utils_const = __webpack_require__(96519);
// EXTERNAL MODULE: ./utils/units.js
var units = __webpack_require__(55741);
// EXTERNAL MODULE: ./utils/build-link.js
var build_link = __webpack_require__(93471);
;// CONCATENATED MODULE: ./components/map/index.jsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/* eslint-disable @next/next/no-img-element */ 








function MapEmbed() {
    var ref5 = (0,react.useState)([]), annotations = ref5[0], setAnnotations = ref5[1];
    var ref1 = (0,dist.useMap)({
        showsPointsOfInterest: false,
        showsUserLocation: true,
        tracksUserLocation: true,
        showsUserLocationControl: true,
        _allowWheelToZoom: true
    }), mapkit = ref1.mapkit, map = ref1.map, mapProps = ref1.mapProps;
    var mutate = (0,swr_dist/* useSWRConfig */.kY)().mutate;
    var ref2 = (0,swr_dist/* default */.ZP)("/api/geo", fetcher/* default */.Z, {
        fallback: {
            latitude: 33.812062499999996,
            longitude: -117.91893750000001
        }
    }), geo = ref2.data;
    var ref3 = (0,swr_dist/* default */.ZP)("map", function() {
        var ref, ref4;
        if (!map) {
            return;
        }
        var center = map === null || map === void 0 ? void 0 : (ref = map.region) === null || ref === void 0 ? void 0 : ref.center;
        var span = map === null || map === void 0 ? void 0 : (ref4 = map.region) === null || ref4 === void 0 ? void 0 : ref4.span;
        var searchDelta = Math.max((span === null || span === void 0 ? void 0 : span.latitudeDelta) || 0.16, (span === null || span === void 0 ? void 0 : span.longitudeDelta) || 0.16);
        var searchDistance = searchDelta * 111000;
        return (0,fetcher/* default */.Z)({
            method: "POST",
            url: "".concat(utils_const/* SEARCH_URL */.vA, "/indexes/omnisearch/search"),
            data: {
                filter: "_geoRadius(".concat((center === null || center === void 0 ? void 0 : center.latitude) || geo.latitude, ",").concat((center === null || center === void 0 ? void 0 : center.longitude) || geo.longitude, ", ").concat(searchDistance, ") AND (contentType=park ").concat(searchDistance < 2000 ? "OR contentType=attraction" : "", ")"),
                sort: [
                    "_geoPoint(".concat((center === null || center === void 0 ? void 0 : center.latitude) || geo.latitude, ",").concat((center === null || center === void 0 ? void 0 : center.longitude) || geo.longitude, "):asc"), 
                ],
                limit: 500
            },
            headers: {
                Authorization: "Bearer ".concat(utils_const/* SEARCH_TOKEN */.wf)
            }
        });
    }), searchResults = ref3.data;
    (0,react.useEffect)(function() {
        if ((geo === null || geo === void 0 ? void 0 : geo.latitude) && (geo === null || geo === void 0 ? void 0 : geo.longitude) && map && mapkit) {
            var spanDelta = (0,units/* MetersFromMiles */.i)(100) / 111000;
            var center = new mapkit.Coordinate(geo.latitude, geo.longitude);
            var span = new mapkit.CoordinateSpan(spanDelta, spanDelta);
            var region = new mapkit.CoordinateRegion(center, span);
            map.setRegionAnimated(region, false);
            mutate("map");
        }
    }, [
        geo,
        map,
        mapkit,
        mutate
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!searchResults || !mapkit) {
            return;
        }
        var hits = (searchResults === null || searchResults === void 0 ? void 0 : (ref = searchResults.hits) === null || ref === void 0 ? void 0 : ref.filter(function(hit) {
            return typeof hit.id === "string";
        })) || [];
        var calloutDelegate = {
            calloutElementForAnnotation: function calloutElementForAnnotation(annotation) {
                var _data = annotation.data, image = _data.photo, url = _data.url, title = _data.title, contentType = _data.contentType, parentName = _data.parentName;
                var isRestroom = title.toLowerCase().includes("restroom");
                var callout = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative h-full w-full bg-white shadow-xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full flex-col md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-1/2 w-full md:h-full md:w-1/2",
                                children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext),
                                    srcSet: "\n                https://images.opencoaster.com/800x400/".concat(image.hash).concat(image.ext, " 800w,\n                https://images.opencoaster.com/600x300/").concat(image.hash).concat(image.ext, " 600w,\n                https://images.opencoaster.com/400x200/").concat(image.hash).concat(image.ext, " 400w,\n                https://images.opencoaster.com/300x150/").concat(image.hash).concat(image.ext, " 300w,\n                https://images.opencoaster.com/200x100/").concat(image.hash).concat(image.ext, " 200w,\n                https://images.opencoaster.com/100x50/").concat(image.hash).concat(image.ext, " 100w\n              "),
                                    alt: image.alternativeText ? image.alternativeText : title,
                                    className: "h-full w-full object-cover object-center"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "h-full w-full bg-gray-200 object-contain object-center",
                                    src: "/placeholder-".concat(isRestroom ? "restroom" : contentType, ".svg"),
                                    alt: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-1/2 w-full flex-col justify-center p-4 md:h-full md:w-1/2",
                                children: [
                                    contentType === "attraction" && parentName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3 text-sm text-gray-500",
                                        children: parentName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-xl font-semibold text-gray-900",
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: url,
                                        className: "text-sm font-medium text-indigo-600 hover:text-indigo-500",
                                        children: [
                                            "View ",
                                            isRestroom ? "restroom" : contentType,
                                            " \u2192"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
                var element = document.createElement("div");
                element.className = "w-[300px] md:w-[500px] h-[320px] md:h-[160px]";
                (0,react_dom.render)(callout, element);
                return element;
            }
        };
        setAnnotations(hits.map(function(hit) {
            var isRestroom = hit.title.toLowerCase().includes("restroom");
            return new mapkit.MarkerAnnotation(new mapkit.Coordinate(hit._geo.lat, hit._geo.lng), {
                title: hit.title,
                subtitle: hit.parentName,
                clusteringIdentifier: hit.contentType,
                glyphImage: {
                    1: "/placeholder-".concat(isRestroom ? "restroom" : hit.contentType, ".svg")
                },
                callout: calloutDelegate,
                data: _objectSpread({
                    url: (0,build_link/* default */.Z)(hit)
                }, hit)
            });
        }));
    }, [
        searchResults,
        mapkit,
        map
    ]);
    (0,react.useEffect)(function() {
        if (map && Array.isArray(annotations)) {
            if (!deep_equal_default()(map.annotations, annotations)) {
                map.annotations = annotations;
            }
        }
    }, [
        annotations,
        map
    ]);
    (0,react.useEffect)(function() {
        if (!map) {
            return;
        }
        var onRegionChange = function() {
            mutate("map");
        };
        map.addEventListener("region-change-end", onRegionChange);
        return function() {
            map.removeEventListener("region-change-end", onRegionChange);
        };
    }, [
        map,
        mutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Map, _objectSpread({}, mapProps));
};

;// CONCATENATED MODULE: ./pages/map.jsx





var __N_SSG = true;
function MapPage(param) {
    var fallback = param.fallback;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(config/* default */.Z, {
        fallback: fallback,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Theme Park & Attractions Map - Open Coaster"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[calc(100vh-4rem)] w-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.MapkitProvider, {
                    tokenOrCallback: "/api/map/token",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapEmbed, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 62412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var fetcher = function(url) {
    return axios__WEBPACK_IMPORTED_MODULE_0___default()(url).then(function(res) {
        return res.data;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (fetcher);


/***/ }),

/***/ 92233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ query1; }
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28687);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96519);


function query1(query, args) {
    var variables = args;
    var token;
    if (args === null || args === void 0 ? void 0 : args.variables) {
        variables = args.variables;
    }
    if ((args === null || args === void 0 ? void 0 : args.token) && typeof (args === null || args === void 0 ? void 0 : args.token) === "string") {
        token = args.token;
    }
    var client = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient(utils_const__WEBPACK_IMPORTED_MODULE_1__/* .GRAPH_URL */ .Vd);
    if (token) {
        client.setHeader("authorization", "Bearer ".concat(token));
    }
    return client.request(query, variables);
};


/***/ }),

/***/ 55741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ MetersFromMiles; }
/* harmony export */ });
var METERS_PER_MILE = 1609.344;
function MetersFromMiles(miles) {
    return METERS_PER_MILE * miles;
}


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [533,659,774,888,179], function() { return __webpack_exec__(93223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);